import { Mutation } from 'graphql/generated/graphqlTypes';

export const mockedBulkDeleteVisitorsData = (): Pick<Mutation, 'bulkDeleteVisitors'> => ({
  bulkDeleteVisitors: {
    deletedVisitorIds: ['mockedVisitorIdExternalUser1'],
    errors: []
  }
});
